const getTokenFromCookie = (): string | undefined =>
  document.cookie
    .split('; ')
    .find((item) => item.startsWith('csrftoken='))
    ?.split('=')[1];

async function fetchPerlgemCSRFToken(): Promise<string | undefined> {
  const body = new URLSearchParams();
  body.append(
    'JSONRPC',
    JSON.stringify([
      {
        method: 'csrf.getToken',
        params: [{}]
      }
    ])
  );

  const response = await fetch(`/rpc/jsonrpc.tmpl?dbgmethod=csrf.getToken`, {
    method: 'POST',
    body
  });

  if (response.status !== 200) {
    return '';
  }

  const responseObj = await response.json();

  return responseObj[0]?.result?.value?.token;
}

async function getPerlgemCSRFToken(): Promise<string | undefined> {
  let token = getTokenFromCookie();

  if (token === undefined) {
    token = await fetchPerlgemCSRFToken();
  }

  return token;
}

export default getPerlgemCSRFToken;
